import { render, staticRenderFns } from "./SectionHome.vue?vue&type=template&id=3f260200&scoped=true&"
import script from "./SectionHome.vue?vue&type=script&lang=js&"
export * from "./SectionHome.vue?vue&type=script&lang=js&"
import style0 from "./SectionHome.vue?vue&type=style&index=0&id=3f260200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f260200",
  null
  
)

export default component.exports